import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Button, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Iconify from '../../components/iconify';
import { bgBlur } from '../../utils/cssStyles';
import { otpBorrowerLogout } from '../../service/otpApi';

const NAV_WIDTH = 280;
const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 80;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

BorrowerHeader.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function BorrowerHeader({ onOpenNav }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await otpBorrowerLogout();
    } catch (e) {
      // ignore
    }
    navigate('/borrower/login', { replace: true });
  };

  return (
    <StyledRoot>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{ mr: 1, color: 'text.primary', display: { lg: 'none' } }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={1}>
          <Tooltip title="Back to My Loans">
            <IconButton onClick={() => navigate('/borrower/loans')} sx={{ color: 'text.primary' }}>
              <Iconify icon="mdi:home-outline" />
            </IconButton>
          </Tooltip>
          <Button
            variant="outlined"
            size="small"
            onClick={handleLogout}
            startIcon={<Iconify icon="mdi:logout" />}
          >
            Logout
          </Button>
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
